export default __webpack_public_path__ + "static/index-ed65080a458f6a63c97b17f8b7954414.png";